import { HeaderActionsService } from '@adminprodigydesign/axis';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

type DayHours = {
  day: string;
  isClosed?: boolean;
  open?: Date | string;
  close?: Date | string;
  intervals?: { open: Date | string; close: Date | string }[];
};

@Component({
  selector: 'app-restaurant-info-modal',
  standalone: false,
  templateUrl: './restaurant-info-modal.component.html',
  styleUrl: './restaurant-info-modal.component.scss',
})
export class RestaurantInfoModalComponent implements OnInit, OnDestroy {
  @Input() restaurantName = 'Restaurant';
  @Input() allergensNote = '';
  @Input() restaurantAddress = '';
  @Input() restaurantPhone = '';
  @Input() openingHours: DayHours[] = [];
  @Input() deliveryHours: DayHours[] = [];
  @Input() fees?: {
    minOrder: number;
    deliveryFee: number;
    serviceFee?: number;
  };

  showInfo = false;

  private sub = new Subscription();

  constructor(private headerActionService: HeaderActionsService) {}

  ngOnInit(): void {
    this.sub.add(
      this.headerActionService.infoClick$.subscribe(() => {
        this.showInfo = true;
      }),
    );
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  formatTime(value?: string | Date): string {
    if (!value) return '—';

    if (value instanceof Date) {
      return new Intl.DateTimeFormat(undefined, {
        hour: 'numeric',
        minute: '2-digit',
      }).format(value);
    }

    const parts = value.split(':').map(Number);
    if (parts.length < 2) return value;

    const d = new Date();
    d.setHours(parts[0] || 0, parts[1] || 0, 0, 0);

    return new Intl.DateTimeFormat(undefined, {
      hour: 'numeric',
      minute: '2-digit',
    }).format(d);
  }
}
